import React from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import { useHeaderConfig } from "../../NavProvider";
import AstroLogo from "../AstroLogo";
import Categories from "./Categories";
import Container from "../Container";
var useStyles = makeStyles(function () {
    return createStyles({
        nav: {
            display: "flex",
            alignItems: "center",
            height: "80px",
            WebkitTapHighlightColor: "transparent",
        },
    });
});
var SubNav = function () {
    var styles = useStyles();
    var header = useHeaderConfig();
    return (React.createElement(Container, null,
        React.createElement("nav", { className: styles.nav },
            React.createElement(AstroLogo, { logo: header.logo }),
            React.createElement(Categories, { categories: header.navItems }))));
};
export default SubNav;
